export default function ExchangeIcon({ size = 42 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="38" width="4" height="30" transform="rotate(-180 8 38)" fill="url(#paint0_linear_1523_555)" />
            <path d="M4 6H36V28" stroke="url(#paint1_linear_1523_555)" strokeWidth="4" />
            <circle cx="21" cy="18" r="4" fill="black" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13 28.0349H12.1614L11.5736 28.633L8 32.269V37.9754L13.8386 32.0349H38V28.0349H13Z" fill="black" />
            <defs>
                <linearGradient id="paint0_linear_1523_555" x1="9.99993" y1="43.8065" x2="9.99986" y2="68" gradientUnits="userSpaceOnUse">
                    <stop offset="0.131883" />
                    <stop offset="0.876" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="paint1_linear_1523_555" x1="36" y1="12" x2="36" y2="28" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}
